import React from 'react';
import useChartData from './useChartData';
import {Chart} from '../../BarChart';
import DashboardItemContainer from '../../../Container';

export default () => {
  const chart = useChartData();

  return (
    <DashboardItemContainer
      title="ToDo分析"
      subTitle="月別"
      tags={['ステータス', '過去6ヶ月']}>
      <Chart chart={chart} legend={false} className="h-full w-full" />
    </DashboardItemContainer>
  );
};
